import hexToRgb from 'hex-rgb';
import PropTypes from 'prop-types';

import cssGlobals from '../../main/css/globals';
import { classList } from '../../utils';
import transformHtml from '../../utils/transformHtml';
import styles from './styles.scss';

Text.propTypes = {
  // Supports either a string of HTML or React children.
  html: PropTypes.string,
  children: PropTypes.node,
  // Maximum number of lines.
  // undefined → no clamping
  // 1 → ellipsis
  // 2 → ellipsis in WebKit and Blink, just cut off in others
  // 3 → last line is faded out
  clampLines: PropTypes.number,
  // The color to fade out the last line with. Only hex notation is supported.
  clampColor: PropTypes.string,
  className: PropTypes.string,
};

/**
 * This components styles its children as a document: Space between paragraphs,
 * lists have bullets, links looks like links, etc.
 *
 * It also allows clamping the text to roughly a specified number of lines.
 */
export default function Text({
  html,
  clampLines,
  clampColor = '#fff',
  className = '',
  children = null,
}) {
  return (
    <div
      style={
        clampLines == null
          ? undefined
          : {
              maxHeight: `${clampLines * cssGlobals['g-line-height']}em`,
              overflow: 'hidden',
              position: 'relative',
            }
      }
    >
      <div
        className={classList({
          [styles.inner]: true,
          [styles.clamp1]: clampLines === 1,
          [styles.clamp2]: clampLines === 2,
          [styles.editorStyles]: clampLines === undefined,
          [className]: true,
        })}
        dangerouslySetInnerHTML={
          html == null ? undefined : { __html: transformHtml(html) }
        }
      >
        {children}
      </div>

      {clampLines >= 3 && (
        <div
          className={styles.fade}
          style={{
            backgroundImage: makeGradient(clampColor),
          }}
        />
      )}
    </div>
  );
}

function makeGradient(color) {
  const { red, green, blue } = hexToRgb(color);
  return `linear-gradient(to top, ${color}, rgba(${red}, ${green}, ${blue}, 0))`;
}
